<template>
  <el-dialog
    title="返优惠账户调整申请"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show', false)">
    <el-form ref="form" label-width="140px">
      <el-form-item label="返优惠调整申请单号">{{detailData.code}}</el-form-item>
      <el-form-item label="状态">{{detailData.statusName}}</el-form-item>
      <el-form-item label="调整金额" >{{detailData.totalAdjustAmount}}</el-form-item>
      <el-form-item label="申请人" >{{detailData.createPerson}}</el-form-item>
      <el-form-item label="申请时间" >{{detailData.createTime}}</el-form-item>
      <el-form-item label="审核时间" >{{detailData.applyDate}}</el-form-item>
      <el-form-item label="调整类型" >{{detailData.typeName}}</el-form-item>
      <el-form-item label="调整原因" >{{detailData.reason}}</el-form-item>
    </el-form>
    <el-table :data="list" style="width: 100%" >
      <el-table-column
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="adjustAmount"
        label="调整金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="year"
        label="产生年份"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="isEquityFund"
        label="是否权益金"
        show-overflow-tooltip>
        <template slot-scope="scope">{{scope.row.isEquityFund === 0 ? '否' : '是'}}</template>
      </el-table-column>
      <el-table-column
        prop="usePolicyName"
        label="返优惠使用规则"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="expiredDate"
        label="过期时间"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="detailData.detailDtos.length"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'infoViewDialog',
  props: ['show', 'info'],
  components: { },
  data () {
    return {
      visible: false,
      detailData: { detailDtos: [] },
      list: [],
      listState: {
        pageSize: 10,
        pageNo: 1
      }
    }
  },
  computed: {
  },
  mounted () {
    this.visible = true
    this.getDetail()
  },
  methods: {
    ...mapActions(['findOneAdjustAccount']),
    getDetail () {
      this.findOneAdjustAccount({ id: this.info.id }).then(res => {
        this.detailData = res.data
        this.handleSearch()
      })
    },
    // 搜索
    handleSearch () {
      const { pageSize, pageNo } = this.listState
      this.list = this.$lodash.cloneDeep(this.detailData.detailDtos).splice(pageSize * (pageNo - 1), pageSize)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleSearch()
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 215px;
}
.height-over-scroll{
  max-height: 400px;
  overflow-y: scroll;
}
.height-over-scroll::-webkit-scrollbar {
  display: none;
}
.el-card {
  width: 550px;
  p {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    .el-input {
      width: 100px;
    }
    span {
      display: inline-block;
      margin: 0 10px;
    }
  }
}
</style>
